module.exports = __webpack_public_path__ + "img/logo1.ae133b10.png";